<template>
  <v-dialog
    :value="true"
    persistent
    max-width="300"
  >
    <v-card
      min-height="100"
      :loading="loading"
    >
      <v-card-title class="text-h5">
        <template v-if="noService">
          {{ $t('Text.NotAllowed.NoService') }}
        </template>
        <template v-else-if="noFunction">
          {{ $t('Text.NotAllowed.NoFunction') }}
        </template>
      </v-card-title>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="primary"
          text
          @click="backClick"
        >
          {{ $t('PublicServant.Action.Back') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { NOT_ALLOWED_REASON } from '@/constant/constant'

export default {
  props: {
    reasonType: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    noService: function () {
      return this.reasonType === NOT_ALLOWED_REASON.NO_SERVICE
    },
    noFunction: function () {
      return this.reasonType === NOT_ALLOWED_REASON.NO_FUNCTION
    }
  },
  methods: {
    backClick: function () {
      this.loading = true
      window.history.go(-2)
    }
  }
}
</script>
